import ButtonComponent, { StyledButton } from '../../../Button.component';
import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { StatusDuplicateCandidate } from '../CandidateDuplicateModal.component';
import TooltipComponent from '../../../Tooltip.component';
import { StyledTooltipWrapper } from '../../../../styles';
import { ERROR_CODE } from '../../../../constants/error.constant';
import CandidateUnmergeButton from './CandidateUnmergeButton';

interface CandidateFooterProps {
  isDisable: boolean;
  handleAction: (value: boolean) => void;
  handleClose: () => void;
  status?: StatusDuplicateCandidate;
}

const StyledCandidateFooterBlock = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;

const StyledCandidateFooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  gap: 10px;

  ${StyledButton} {
    min-width: 100px;
  }
`;

const CandidateFooter: FC<CandidateFooterProps> = ({
  handleAction,
  handleClose,
  isDisable,
  status,
}) => {
  const { t } = useTranslation();
  const isDisableUnmergeButton = status === ERROR_CODE.CANDIDATE_DUPLICATE_HARD;

  return (
    <StyledCandidateFooterWrapper>
      <StyledCandidateFooterBlock>
        <ButtonComponent
          disabled={isDisable}
          appearance="primary"
          handleClick={() => handleAction(false)}
          style={{ width: '100%' }}
        >
          {t('Merge')}
        </ButtonComponent>
      </StyledCandidateFooterBlock>
      <StyledCandidateFooterBlock>
        {isDisableUnmergeButton ? (
          <StyledTooltipWrapper left="-8rem">
            <TooltipComponent
              width="max-content"
              tooltip={t('personDuplicate.duplicateWarningText')}
            />
            <CandidateUnmergeButton
              handleAction={handleAction}
              isDisable={isDisableUnmergeButton}
            />
          </StyledTooltipWrapper>
        ) : (
          <CandidateUnmergeButton
            handleAction={handleAction}
            isDisable={isDisableUnmergeButton}
          />
        )}
        <ButtonComponent handleClick={handleClose}>{t('Back')}</ButtonComponent>
      </StyledCandidateFooterBlock>
    </StyledCandidateFooterWrapper>
  );
};

export default CandidateFooter;
